export const FILE_ERROR_TYPES = {
  FILE_SIZE: {
    type: 'fileSize',
    message: _TL_('File is either too large or too small'),
  },
  FILE_TYPE: {
    type: 'fileType',
    message: _TL_('File type is not allowed'),
  },
  FILE_COUNT: {
    type: 'fileCount',
    message: _TL_('Maximum number of files exceeded'),
  },
  UPLOAD_FAILED: {
    type: 'uploadFailed',
    message: _TL_('File upload failed'),
  },
};

export const DEFAULT_MAX_SIZE = 1 * 1024 * 1024;

export const LegacyStringMap = {
  FilePicker_ButtonText_ChooseFile: _TL_('Browse'),
  FilePicker_ButtonText_RemoveFile: _TL_('Remove'),
  FilePicker_FileExtensionInvalid: _TL_('File extension is invalid'),
  FilePicker_FileInvalid: _TL_('File is invalid'),
};
